import { render, staticRenderFns } from "./sblog-category.vue?vue&type=template&id=28e59b20&"
import script from "./sblog-category.vue?vue&type=script&lang=js&"
export * from "./sblog-category.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports